import * as yup from "yup";
export const CreateNewClassSchema = yup
  .object()
  .shape({
    name: yup.string().required("Name of Class is Required"),
    drescription: yup.string().required("Class Description is Required"),
    instructorId: yup.number(),
    startDate: yup.date().required("Start Date is Required"),
    endDate: yup.date().required("End Date is Required"),
    active: yup.boolean(),
    createDate: yup.date(),
  });
